module.exports = __webpack_public_path__ + "static/img/bannerBg4_en.908408c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bannerBg4_en.png
// module id = EwJS
// module chunks = 1